// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../../graphql/public/PublicSchemaTypes';

import { UserDetailFragment } from '../../../public-api/hooks/usePublicApiSession.codegen';
import { gql } from '@apollo/client';
import { UserDetailFragmentDoc } from '../../../public-api/hooks/usePublicApiSession.codegen';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type SelfSignupWithSecretLinkMutationVariables = PublicSchemaTypes.Exact<{
  token: PublicSchemaTypes.Scalars['UUID'];
  userInput: PublicSchemaTypes.SecretLinkSignUpInput;
  securityQuestions?: PublicSchemaTypes.Maybe<Array<PublicSchemaTypes.SecurityQuestionsDataInput> | PublicSchemaTypes.SecurityQuestionsDataInput>;
}>;


export type SelfSignupWithSecretLinkMutation = (
  { __typename?: 'Mutation' }
  & { organisation?: PublicSchemaTypes.Maybe<(
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PublicSchemaTypes.OrganisationModelGqlBase, 'id'>
    & { secretSelfSignupLink?: PublicSchemaTypes.Maybe<(
      { __typename?: 'SecretSignupLinkModel' }
      & { signUp?: PublicSchemaTypes.Maybe<(
        { __typename?: 'UserSessionModel' }
        & Pick<PublicSchemaTypes.UserSessionModel, 'id' | 'sid'>
      )> }
    )> }
  )> }
);

export type LoginToExistingAccountWithVerificationFlowMutationVariables = PublicSchemaTypes.Exact<{
  accountName: PublicSchemaTypes.Scalars['NonEmptyString'];
  verificationData: PublicSchemaTypes.UserVerificationDataInput;
  additionalData: PublicSchemaTypes.LoginAndSetPasswordWithAdditionalDataInput;
  questionAnswers?: PublicSchemaTypes.Maybe<Array<PublicSchemaTypes.SecurityQuestionsDataInput> | PublicSchemaTypes.SecurityQuestionsDataInput>;
}>;


export type LoginToExistingAccountWithVerificationFlowMutation = (
  { __typename?: 'Mutation' }
  & { loginToExistingAccountWithVerificationFlow?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserSessionModelSelf' }
    & Pick<PublicSchemaTypes.UserSessionModelSelf, 'expires' | 'created_at'>
    & { user: (
      { __typename?: 'UserModelSelf' }
      & UserDetailFragment
    ) }
  )> }
);

export type LoginAndSaveSecurityQuestionsMutationVariables = PublicSchemaTypes.Exact<{
  password: PublicSchemaTypes.Scalars['String'];
  accountNameOrEmail: PublicSchemaTypes.Scalars['NonEmptyString'];
  additionalData: PublicSchemaTypes.LoginAndSetAdditionalDataInput;
  questionAnswers: Array<PublicSchemaTypes.SecurityQuestionsDataInput> | PublicSchemaTypes.SecurityQuestionsDataInput;
}>;


export type LoginAndSaveSecurityQuestionsMutation = (
  { __typename?: 'Mutation' }
  & { loginAndSaveSecurityQuestions?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserSessionModel' }
    & Pick<PublicSchemaTypes.UserSessionModel, 'id'>
  )> }
);


export const SelfSignupWithSecretLinkDocument = gql`
    mutation selfSignupWithSecretLink($token: UUID!, $userInput: SecretLinkSignUpInput!, $securityQuestions: [SecurityQuestionsDataInput!]) {
  organisation {
    id
    secretSelfSignupLink(token: $token) {
      signUp(userInput: $userInput, securityQuestions: $securityQuestions) {
        id
        sid
      }
    }
  }
}
    `;
export type SelfSignupWithSecretLinkMutationFn = Apollo.MutationFunction<SelfSignupWithSecretLinkMutation, SelfSignupWithSecretLinkMutationVariables>;

/**
 * __useSelfSignupWithSecretLinkMutation__
 *
 * To run a mutation, you first call `useSelfSignupWithSecretLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfSignupWithSecretLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfSignupWithSecretLinkMutation, { data, loading, error }] = useSelfSignupWithSecretLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *      userInput: // value for 'userInput'
 *      securityQuestions: // value for 'securityQuestions'
 *   },
 * });
 */
export function useSelfSignupWithSecretLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelfSignupWithSecretLinkMutation, SelfSignupWithSecretLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelfSignupWithSecretLinkMutation, SelfSignupWithSecretLinkMutationVariables>(SelfSignupWithSecretLinkDocument, options);
      }
export type SelfSignupWithSecretLinkMutationHookResult = ReturnType<typeof useSelfSignupWithSecretLinkMutation>;
export type SelfSignupWithSecretLinkMutationResult = Apollo.MutationResult<SelfSignupWithSecretLinkMutation>;
export type SelfSignupWithSecretLinkMutationOptions = Apollo.BaseMutationOptions<SelfSignupWithSecretLinkMutation, SelfSignupWithSecretLinkMutationVariables>;
export const LoginToExistingAccountWithVerificationFlowDocument = gql`
    mutation loginToExistingAccountWithVerificationFlow($accountName: NonEmptyString!, $verificationData: UserVerificationDataInput!, $additionalData: LoginAndSetPasswordWithAdditionalDataInput!, $questionAnswers: [SecurityQuestionsDataInput!]) {
  loginToExistingAccountWithVerificationFlow(
    accountName: $accountName
    verificationData: $verificationData
    additionalData: $additionalData
    questionAnswers: $questionAnswers
  ) {
    user {
      ...userDetail
    }
    expires
    created_at
  }
}
    ${UserDetailFragmentDoc}`;
export type LoginToExistingAccountWithVerificationFlowMutationFn = Apollo.MutationFunction<LoginToExistingAccountWithVerificationFlowMutation, LoginToExistingAccountWithVerificationFlowMutationVariables>;

/**
 * __useLoginToExistingAccountWithVerificationFlowMutation__
 *
 * To run a mutation, you first call `useLoginToExistingAccountWithVerificationFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginToExistingAccountWithVerificationFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginToExistingAccountWithVerificationFlowMutation, { data, loading, error }] = useLoginToExistingAccountWithVerificationFlowMutation({
 *   variables: {
 *      accountName: // value for 'accountName'
 *      verificationData: // value for 'verificationData'
 *      additionalData: // value for 'additionalData'
 *      questionAnswers: // value for 'questionAnswers'
 *   },
 * });
 */
export function useLoginToExistingAccountWithVerificationFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginToExistingAccountWithVerificationFlowMutation, LoginToExistingAccountWithVerificationFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginToExistingAccountWithVerificationFlowMutation, LoginToExistingAccountWithVerificationFlowMutationVariables>(LoginToExistingAccountWithVerificationFlowDocument, options);
      }
export type LoginToExistingAccountWithVerificationFlowMutationHookResult = ReturnType<typeof useLoginToExistingAccountWithVerificationFlowMutation>;
export type LoginToExistingAccountWithVerificationFlowMutationResult = Apollo.MutationResult<LoginToExistingAccountWithVerificationFlowMutation>;
export type LoginToExistingAccountWithVerificationFlowMutationOptions = Apollo.BaseMutationOptions<LoginToExistingAccountWithVerificationFlowMutation, LoginToExistingAccountWithVerificationFlowMutationVariables>;
export const LoginAndSaveSecurityQuestionsDocument = gql`
    mutation loginAndSaveSecurityQuestions($password: String!, $accountNameOrEmail: NonEmptyString!, $additionalData: LoginAndSetAdditionalDataInput!, $questionAnswers: [SecurityQuestionsDataInput!]!) {
  loginAndSaveSecurityQuestions(
    password: $password
    accountNameOrEmail: $accountNameOrEmail
    additionalData: $additionalData
    questionAnswers: $questionAnswers
  ) {
    id
  }
}
    `;
export type LoginAndSaveSecurityQuestionsMutationFn = Apollo.MutationFunction<LoginAndSaveSecurityQuestionsMutation, LoginAndSaveSecurityQuestionsMutationVariables>;

/**
 * __useLoginAndSaveSecurityQuestionsMutation__
 *
 * To run a mutation, you first call `useLoginAndSaveSecurityQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAndSaveSecurityQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAndSaveSecurityQuestionsMutation, { data, loading, error }] = useLoginAndSaveSecurityQuestionsMutation({
 *   variables: {
 *      password: // value for 'password'
 *      accountNameOrEmail: // value for 'accountNameOrEmail'
 *      additionalData: // value for 'additionalData'
 *      questionAnswers: // value for 'questionAnswers'
 *   },
 * });
 */
export function useLoginAndSaveSecurityQuestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginAndSaveSecurityQuestionsMutation, LoginAndSaveSecurityQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginAndSaveSecurityQuestionsMutation, LoginAndSaveSecurityQuestionsMutationVariables>(LoginAndSaveSecurityQuestionsDocument, options);
      }
export type LoginAndSaveSecurityQuestionsMutationHookResult = ReturnType<typeof useLoginAndSaveSecurityQuestionsMutation>;
export type LoginAndSaveSecurityQuestionsMutationResult = Apollo.MutationResult<LoginAndSaveSecurityQuestionsMutation>;
export type LoginAndSaveSecurityQuestionsMutationOptions = Apollo.BaseMutationOptions<LoginAndSaveSecurityQuestionsMutation, LoginAndSaveSecurityQuestionsMutationVariables>;